import { render, staticRenderFns } from "./jiameng.vue?vue&type=template&id=85366f4e&scoped=true&"
import script from "./jiameng.vue?vue&type=script&lang=js&"
export * from "./jiameng.vue?vue&type=script&lang=js&"
import style0 from "./jiameng.vue?vue&type=style&index=0&id=85366f4e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85366f4e",
  null
  
)

export default component.exports